import React from "react";

import Container from "../components/container";
import Layout from "../components/layout";

const PrivacyPolicy = () => {
  return (
    <Layout>
      <Container className="py-[48px]">
        <h2 className="heading" style={{ marginBottom: "1.5rem" }}>
          Informativa Privacy
        </h2>

        <div className="text-base">
          <h2>AI SENSI DELL’ART. 13 DEL REGOLAMENTO UE 2016/ 679</h2>
          <p>
            In Buona Salute S.r.l. Società Benefit,
            in qualità di Titolare del trattamento dei vostri dati personali,
            garantisce e si assicura che tutte le vostre informazioni
            siano trattate tramite la presente Piattaforma (la “Piattaforma”)
            nel rispetto delle prescrizioni previste dal Regolamento
            UE 2016/679 (“GDPR“) in materia di protezione dei dati personali.
          </p>
          <br/>
          <h2>Identità e dati di contatto del Titolare del trattamento</h2>
          <p>Il Titolare del trattamento dei vostri dati personali è In Buona Salute S.r.l.
            Società Benefit, con sede legale in Milano (MI),
            Piazzale Giulio Cesare 4, iscritta al registro delle
            imprese di Milano al n. 13561940969 (di seguito “Titolare”),
            con i seguenti dati di contatto: supporto@inbuonasalute.eu.
          </p>
          <br/>
          <h2>Quali informazioni raccogliamo e trattiamo</h2>
          <p>
            Attraverso la Piattaforma otteniamo e conserviamo le informazioni
            relative all’utente in vari modi.
            <span className="underline block">Informazioni fornite direttamente dall’utente</span>
            La Piattaforma raccoglie le seguenti informazioni fornite direttamente dall’utente:
          </p>
          <ul>
            <li>dati identificativi (quali nome, cognome, genere, etc.);</li>
            <li>dati di contatto (come email, dati account email scelta dall’utente per
              loggarsi ai servizi della Piattaforma, numero di telefono, etc.);
            </li>
            <li>Dati fiscali;</li>
            <li>eventuali altre informazioni inserite facoltativamente
              dall’utente tramite l’utilizzo della Piattaforma.
            </li>
          </ul>
          <br/>
          <h2>Per quali finalità raccogliamo i vostri dati</h2>
          <p>
            Il Titolare tratterà, tramite la Piattaforma,
            i vostri dati personali per le seguenti finalità:
            <br/>a) identificare l’utente e autenticarlo in modo sicuro;
            <br/>b) fornire all’utente i servizi erogati tramite la piattaforma;
            <br/>c) per la gestione amministrativa e contabile
            dei pagamenti relativi ai servizi erogati tramite la
            Piattaforma;
            <br/>d) per eventuali finalità commerciali e di marketing.
          </p>
          <br/>
          <h2>Qual è la base giuridica che legittima il trattamento dei vostri dati</h2>
          <p>
            Il Titolare tratta i vostri dati personali in base alla
            sottoscrizione delle condizioni generali di servizio accettate
            in fase di registrazione alla Piattaforma
            ai sensi dell’art. 6, comma 1, lettera b) del GDPR.
            <br/>Il Titolare tratta i vostri dati personali anche in base
            al vostro consenso esplicito ed informato per finalità
            di cui alla lettera d) che precede,
            ai sensi dell’art. 6, comma 1, lettera a), GDPR.
            <br/>Avete sempre diritto di revocare tale consenso in qualsiasi momento,
            senza pregiudicare la liceità del trattamento effettuato
            dal Titolare e basata sul consenso da voi fornito prima della revoca.
          </p>
          <br/>
          <h2>Con chi condividiamo le vostre informazioni</h2>
          <p>
            Non divulgheremo le vostre informazioni ma le trasferiremo
            unicamente ai Professionisti che collaborano con la nostra
            Società per l’erogazione dei servizi professionali offerti
            dalla nostra
            <br/>Piattaforma, i quali sono vincolati alla più
            rigorosa riservatezza delle informazioni di cui vengono a conoscenza.
            <br/>Potremmo condividere alcune o tutte le vostre
            informazioni con soggetti terzi solo con il vostro consenso, fornito separatamente.
          </p>
          <br/>
          <h2>Per quanto tempo conserviamo le vostre informazioni</h2>
          <p>
            Conserveremo le vostre informazioni,
            raccolte tramite la Piattaforma fino a quando sarete un utente attivo stessa
            e per i dieci anni successivi o fino a quando
            non ci comunicherete la vostra decisione
            di revocare i consensi precedentemente prestati.
          </p>
          <br/>
          <h2>Quali sono i vostri diritti, in qualità di interessati</h2>
          <p>
            Con riferimento ai vostri dati personali, potete esercitare i seguenti diritti:
          </p>
          <ol>
            <li>diritto di accesso ai dati personali;
              diritto di ottenere la rettifica o la cancellazione degli stessi o
              la limitazione del trattamento che li riguardano (artt. 15 – 18 GDPR);
            </li>
            <li>diritto di opporsi al trattamento ex art. 21 GDPR;</li>
            <li>diritto alla portabilità dei dati,
              in relazione ai soli dati in formato elettronico, nei limiti stabiliti
              dall’art. 20 del GDPR.
            </li>
          </ol>
          <br/>
          <h2>Reclamo</h2>
          <p>
            Vi informiamo, inoltre, che avete diritto di contattare direttamente
            il DPO (Data Protection Officer) e,
            ricorrendone le condizioni,
            di proporre reclamo all’Autorità di controllo territorialmente competente,
            così come individuata dagli artt. 3, 55 e 56 GDPR.
          </p>
          <br/>
          <h2>Aggiornamento della presente informativa</h2>
          <p>
            Il Titolare si riserva di aggiornare la presente informativa in ogni momento,
            in caso di inserimento nella Piattaforma di nuove funzionalità e/o servizi.
          </p>
        </div>
      </Container>
    </Layout>
  );
};

export default PrivacyPolicy;
